import script from "./BaseType.vue?vue&type=script&lang=js"
export * from "./BaseType.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__